import { Chip, Select, SelectOption, Stack, Typography } from '@chronosphereio/chrono-ui';
import { TableFormatOverrideKind } from '@/core';

interface FormatSelectOption extends SelectOption {
  key: TableFormatOverrideKind;
}

interface TableColumnFormatEditorProps {
  format: TableFormatOverrideKind;
  originalFormat: TableFormatOverrideKind;
  validFormats: TableFormatOverrideKind[];
  onFormatChange?: (format: TableFormatOverrideKind | undefined) => void;
}

export function TableColumnFormatEditor(props: TableColumnFormatEditorProps) {
  const { format, originalFormat, validFormats, onFormatChange } = props;

  // If only one valid format, show readonly Chip
  if (validFormats.length === 1) {
    return (
      <Stack direction="row" spacing={1}>
        <Typography variant="h4">Type:</Typography>
        <Chip label={format.toString()} />
      </Stack>
    );
  }

  const selectOptions: FormatSelectOption[] = validFormats.map((kind) => ({
    key: kind,
    label: kind,
  }));
  const selectedOption = selectOptions.find((opt) => opt.key === format);
  const allowResetToDefault = format !== originalFormat;

  // Show dropdown when multiple valid formats
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="h4">Type:</Typography>
      <Select
        value={selectedOption}
        onChange={(_, option) => {
          // When cleared, pass undefined to reset the override
          if (option === null) {
            onFormatChange?.(undefined);
          } else if (option?.key) {
            onFormatChange?.(option.key);
          }
        }}
        size="small"
        options={selectOptions}
        disableClearable={!allowResetToDefault}
        sx={{ minWidth: allowResetToDefault ? 135 : 100 }}
        inputProps={{ 'aria-label': 'Column format type' }}
      />
    </Stack>
  );
}
